/**
 * Module: active-flows API
 * Role: Shared types + fetch helper for Home "В прогрессе" cards.
 * Uses: ./client (apiFetch)
 * Used by: screens/HomeScreen/InProgressFlowsBlock
 */
import { apiFetch } from './client';

export type ActiveFlowStepState =
  | 'needs_action'
  | 'checking'
  | 'rejected'
  | 'moderation'
  | 'waiting';

export interface ActiveFlowCard {
  slot_id: string;
  flow_run_id: string;
  campaign_id: string;
  offer_id: string;
  product_title: string;
  product_image_url: string | null;
  marketplace: string;
  cashback_kopecks: number;
  current_step: number;
  total_steps: number;
  current_checkpoint_id: string;
  current_checkpoint_kind: string;
  current_checkpoint_display_name: string | null;
  step_state: ActiveFlowStepState;
}

export interface ActiveFlowListResponse {
  items: ActiveFlowCard[];
}

export async function fetchActiveFlows(limit = 10): Promise<ActiveFlowListResponse> {
  return apiFetch<ActiveFlowListResponse>(`/api/v2/buyer/slots/active-flows?limit=${limit}`);
}
